'use strict';
'use es6';
/* These getters are for use while we transition from `PubNubMessageRecord` messages to `CommonMessage` messages.
  They support both PubNubMessageRecord messages and CommonMessage messages.
  If you find yourself debugging something involving these data structures, consider that there may be a mixture of `CommonMessage` and `PubNubMessageRecord`.
  Dont assume that all `common-message-format` operators are compatible with `PubNubMessageRecord` either, since this is an incomplete list.
  */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConnectedAccountAddress = exports.getMessageDeleteStatus = exports.getEmailMessageId = exports.getCC = exports.getBCC = exports.getToAddresses = exports.getStatus = exports.getAttachments = exports.getFromName = exports.getFromAddress = exports.getSubject = exports.getRichText = exports.getPlainText = exports.getTimestamp = exports.getSenderType = exports.getSenderId = exports.getType = exports.getSenderKey = exports.getInReplyToId = exports.getTopLevelType = exports.getFileIds = exports.getHasMore = exports.getMessageIdForCmf = exports.getStatusTimestamp = exports.getStatusSource = exports.getStatusForCmf = exports.getRichTextForCmf = exports.getPlainTextForCmf = exports.getContentType = exports.getId = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _keyPaths = require('../constants/keyPaths');

var _cmfSenderTypes = require('../constants/cmfSenderTypes');

var _cmfComparators = require('./cmfComparators');

var _getSenderKeyFromType = require('./getSenderKeyFromType');

var _pubnubMessageGetters = require('../../pubnub-message/operators/pubnubMessageGetters');

var PubNubMessageGetters = _interopRequireWildcard(_pubnubMessageGetters);

var _getFileAttachments = require('./getFileAttachments');

var _fileAttachmentGetters = require('./fileAttachmentGetters');

var _cmfSenderInterop = require('../../common-message-format-conversion/operators/cmfSenderInterop');

var _emailMetadataGetters = require('./emailMetadataGetters');

var CmfEmailMetadataGetters = _interopRequireWildcard(_emailMetadataGetters);

var _getMessageDeleteStatus = require('../../pubnub-message/operators/getMessageDeleteStatus');

var _isCommentMessage = require('../../pubnub-message/operators/isCommentMessage');

var _isInitialMessage = require('../../initial-message/operators/isInitialMessage');

var _initialMessageGetters = require('../../initial-message/operators/initialMessageGetters');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getId = exports.getId = (0, _getIn2.default)(_keyPaths.ID);var getContentType = exports.getContentType = (0, _getIn2.default)(_keyPaths.CONTENT_TYPE);

var getPlainTextForCmf = exports.getPlainTextForCmf = (0, _getIn2.default)(_keyPaths.TEXT);

var getRichTextForCmf = exports.getRichTextForCmf = (0, _getIn2.default)(_keyPaths.RICH_TEXT);

var getStatusForCmf = exports.getStatusForCmf = (0, _getIn2.default)(_keyPaths.MESSAGE_STATUS);

var getStatusSource = exports.getStatusSource = (0, _getIn2.default)(_keyPaths.MESSAGE_STATUS_SOURCE);

var getStatusTimestamp = exports.getStatusTimestamp = (0, _getIn2.default)(_keyPaths.MESSAGE_STATUS_TIMESTAMP);

var getMessageIdForCmf = exports.getMessageIdForCmf = (0, _getIn2.default)(_keyPaths.MESSAGE_ID);

var getHasMore = exports.getHasMore = (0, _getIn2.default)(_keyPaths.HAS_MORE);

var getFileIds = exports.getFileIds = (0, _pipe2.default)(_getFileAttachments.getFileAttachments, _fileAttachmentGetters.getFileIds);

var getTopLevelType = exports.getTopLevelType = (0, _getIn2.default)(_keyPaths.TYPE);

var getInReplyToId = exports.getInReplyToId = (0, _getIn2.default)(_keyPaths.IN_REPLY_TO_ID);

var getTimestampForCMF = (0, _getIn2.default)(_keyPaths.TIMESTAMP);

var getSenderTypeForCMF = (0, _getIn2.default)(_keyPaths.SENDER_TYPE);

var getMessageDeleteStatusForCmf = (0, _getIn2.default)(_keyPaths.MESSAGE_DELETE_STATUS);

var getSenderKey = exports.getSenderKey = function getSenderKey(message) {
  var type = getSenderTypeForCMF(message);
  return (0, _getSenderKeyFromType.getSenderKeyFromType)(type);
};

var getSenderIdForCMF = function getSenderIdForCMF(message) {
  if (getSenderTypeForCMF(message) === _cmfSenderTypes.SYSTEM_SENDER) {
    return null;
  }
  return (0, _getIn2.default)(['sender', getSenderKey(message)], message);
};

var getType = exports.getType = function getType(message) {
  var pubnubMessageType = PubNubMessageGetters.getType(message);
  if (pubnubMessageType) {
    return pubnubMessageType;
  } else {
    return getTopLevelType(message);
  }
};

var getSenderId = exports.getSenderId = function getSenderId(message) {
  if ((0, _cmfComparators.isCommonMessageFormat)(message) || (0, _isCommentMessage.isCommentMessage)(message) || (0, _isInitialMessage.isInitialMessage)(message)) {
    return getSenderIdForCMF(message);
  }
  return PubNubMessageGetters.getSenderId(message);
};

var getSenderType = exports.getSenderType = function getSenderType(message) {
  if ((0, _cmfComparators.isCommonMessageFormat)(message) || (0, _isCommentMessage.isCommentMessage)(message) || (0, _isInitialMessage.isInitialMessage)(message)) {
    return (0, _cmfSenderInterop.fromCmfSender)(getSenderTypeForCMF(message));
  }
  return PubNubMessageGetters.getSenderType(message);
};

var getTimestamp = exports.getTimestamp = function getTimestamp(message) {
  if ((0, _cmfComparators.isCommonMessageFormat)(message)) {
    return getTimestampForCMF(message);
  }
  return PubNubMessageGetters.getTimestamp(message);
};

var getPlainText = exports.getPlainText = function getPlainText(message) {
  if ((0, _cmfComparators.isCommonMessageFormat)(message)) {
    return getPlainTextForCmf(message);
  }
  if ((0, _isInitialMessage.isInitialMessage)(message)) {
    return (0, _initialMessageGetters.getText)(message);
  }
  return PubNubMessageGetters.getText(message);
};

var getRichText = exports.getRichText = function getRichText(message) {
  if ((0, _cmfComparators.isCommonMessageFormat)(message)) {
    return getRichTextForCmf(message);
  }
  if ((0, _isInitialMessage.isInitialMessage)(message)) {
    return (0, _initialMessageGetters.getRichText)(message);
  }
  return PubNubMessageGetters.getRichText(message);
};

var getSubject = exports.getSubject = function getSubject(message) {
  return CmfEmailMetadataGetters.getSubject(message);
};

var getFromAddress = exports.getFromAddress = function getFromAddress(message) {
  return CmfEmailMetadataGetters.getFromAddress(message);
};

var getFromName = exports.getFromName = function getFromName(message) {
  return CmfEmailMetadataGetters.getFromName(message);
};

var getAttachments = exports.getAttachments = function getAttachments(message) {
  return getFileIds(message);
};

var getStatus = exports.getStatus = function getStatus(message) {
  if ((0, _cmfComparators.isCommonMessageFormat)(message)) {
    return getStatusForCmf(message);
  }
  return PubNubMessageGetters.getStatus(message);
};

var getToAddresses = exports.getToAddresses = function getToAddresses(message) {
  return CmfEmailMetadataGetters.getToAddresses(message);
};

var getBCC = exports.getBCC = function getBCC(message) {
  return CmfEmailMetadataGetters.getBCC(message);
};

var getCC = exports.getCC = function getCC(message) {
  return CmfEmailMetadataGetters.getCC(message);
};

var getEmailMessageId = exports.getEmailMessageId = function getEmailMessageId(message) {
  return getMessageIdForCmf(message);
};

var getMessageDeleteStatus = exports.getMessageDeleteStatus = function getMessageDeleteStatus(message) {
  if ((0, _cmfComparators.isCommonMessageFormat)(message)) {
    return getMessageDeleteStatusForCmf(message);
  }
  return (0, _getMessageDeleteStatus.getMessageDeleteStatus)(message);
};

var getConnectedAccountAddress = exports.getConnectedAccountAddress = function getConnectedAccountAddress(message) {
  return CmfEmailMetadataGetters.getConnectedAccountAddress(message);
};